import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import UserEditor from './UserEditor';

function AddUser() {
	const navigate = useNavigate();

	return (
		<EntityList>
			<Helmet>
				<title>Crear Usuario</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Configuración', to: '/AdminScreen/Config' },
					{ label: 'Usuarios', to: '/AdminScreen/Config/usuarios' },
					{ label: 'Crear Usuario' },
				]}
				title='Crear Usuario'
				subtitle='Completá los datos principales del usuario.'
			/>
			<UserEditor
				mode='create'
				onCancel={() => navigate('/AdminScreen/Config/usuarios')}
				onSaved={() => navigate('/AdminScreen/Config/usuarios')}
				saveLabel='Crear Usuario'
			/>
		</EntityList>
	);
}

export default AddUser;
